module.exports = __webpack_public_path__ + "img/ch15_09_菜市场装笨.9a608ac6.jpg";